module.exports = __webpack_public_path__ + "static/media/swingHandle_gold.1f318170.png";